<template>
  <div class="absent">

<!--    <span class="bubble-outer-dot"> </span>-->
<!--    <span class="bubble-inner-dot"></span>-->
<!--    <i class="fas fa-exclamation-triangle"></i>-->
    <i class="fas fa-exclamation-circle"></i>
<!--      <i class="fas fa-exclamation bubble-inner-dot"></i>-->


  </div>
</template>

<script>
export default {
  name: 'absent-notify',
  props: ["color"]
}
</script>

<style scoped>
.absent {
  display: inline;
  position: absolute;
  cursor: pointer;
  font-size: 12px;
  top: -4px;
  left: 0px;
  color: #F5A33EFF;
}

/*.bubble:hover:after {*/
/*  background-color: rgba(255, 69, 0, 0.98);*/
/*}*/

/*.bubble:after {*/
/*  content: "";*/
/*  background-color: rgba(255, 69, 0, 0.98);*/
/*  width: 7px;*/
/*  height: 7px;*/
/*  border-radius: 50%;*/
/*  position: absolute;*/
/*  display: block;*/
/*  top: 1px;*/
/*  left: 1px;*/
/*}*/

/*.bubble .bubble-outer-dot {*/
/*  margin: 1px;*/
/*  display: block;*/
/*  text-align: center;*/
/*  opacity: 1;*/
/*  background-color: rgba(255, 81, 0, 0.93);*/
/*  width: 7px;*/
/*  height: 7px;*/
/*  border-radius: 50%;*/
/*  -webkit-animation: bubble-pulse 1.5s linear infinite;*/
/*  -moz-animation: bubble-pulse 1.5s linear infinite;*/
/*  -o-animation: bubble-pulse 1.5s linear infinite;*/
/*  animation: bubble-pulse 1.5s linear infinite*/
/*}*/

/*.bubble .bubble-inner-dot {*/

/*  display: block;*/
/*  text-align: center;*/
/*  opacity: 1;*/
/*  background-color: rgba(255, 81, 0, 0.93);*/
/*  width: 7px;*/
/*  height: 7px;*/
/*  border-radius: 50%;*/
/*  -webkit-animation: bubble-pulse 1.5s linear infinite;*/
/*  -moz-animation: bubble-pulse 1.5s linear infinite;*/
/*  -o-animation: bubble-pulse 1.5s linear infinite;*/
/*  animation: bubble-pulse 1.5s linear infinite*/
/*}*/

/*.bubble .bubble-inner-dot:after {*/
/*  content: "";*/
/*  display: block;*/
/*  text-align: center;*/
/*  opacity: 1;*/
/*  background-color: rgba(255, 81, 0, 0.93);*/
/*  width: 7px;*/
/*  height: 7px;*/
/*  border-radius: 50%;*/
/*  -webkit-animation: bubble-pulse 1.5s linear infinite;*/
/*  -moz-animation: bubble-pulse 1.5s linear infinite;*/
/*  -o-animation: bubble-pulse 1.5s linear infinite;*/
/*  animation: bubble-pulse 1.5s linear infinite*/
/*}*/

/*@-webkit-keyframes bubble-pulse {*/
/*  0% {*/
/*    transform: scale(1);*/
/*    opacity: .75*/
/*  }*/
/*  25% {*/
/*    transform: scale(1);*/
/*    opacity: .75*/
/*  }*/
/*  100% {*/
/*    transform: scale(2.5);*/
/*    opacity: 0*/
/*  }*/
/*}*/

/*@keyframes bubble-pulse {*/
/*  0% {*/
/*    transform: scale(1);*/
/*    opacity: .75*/
/*  }*/
/*  25% {*/
/*    transform: scale(1);*/
/*    opacity: .75*/
/*  }*/
/*  100% {*/
/*    transform: scale(2.5);*/
/*    opacity: 0*/
/*  }*/
/*}*/

/*@-moz-keyframes bubble-pulse {*/
/*  0% {*/
/*    transform: scale(1);*/
/*    opacity: .75*/
/*  }*/
/*  25% {*/
/*    transform: scale(1);*/
/*    opacity: .75*/
/*  }*/
/*  100% {*/
/*    transform: scale(2.5);*/
/*    opacity: 0*/
/*  }*/
/*}*/

/*@-o-keyframes bubble-pulse {*/
/*  0% {*/
/*    transform: scale(1);*/
/*    opacity: .75*/
/*  }*/
/*  25% {*/
/*    transform: scale(1);*/
/*    opacity: .75*/
/*  }*/
/*  100% {*/
/*    transform: scale(2.5);*/
/*    opacity: 0*/
/*  }*/
/*}*/

</style>



// WEBPACK FOOTER //
// src/views/common/absents/absent-notify.vue